// src/utils/quote/quoteAddress.js
// Address display + comparison helpers. betonijerry.fi is Finland-only,
// so Google's ", Finland" / ", Suomi" suffix is redundant on screen and
// also masks the fact that a hand-typed osoite and a Google-picked
// formattedAddress are the same place.

const COUNTRY_SUFFIX = /,\s*(suomi|finland)[.,]?\s*$/i;

export function displayAddress(s) {
    if (!s) return s;
    return String(s).replace(COUNTRY_SUFFIX, "").trim();
}

// Best-effort split of a Finnish address string into street / postal / city.
// Handles Google-polished "Mannerheimintie 12, 00100 Helsinki[, Finland]" and
// falls back to dumping the whole string into street when no postal code is
// detectable (freeform input).
export function parseFiAddress(s) {
    const cleaned = displayAddress(s || "").trim();
    if (!cleaned) return { street: "", postal: "", city: "" };
    const m = cleaned.match(/^(.+?),\s*(\d{5})\s+(.+)$/);
    if (m) return { street: m[1].trim(), postal: m[2], city: m[3].trim() };
    return { street: cleaned, postal: "", city: "" };
}
